import { AccessPlans, StripePlans } from './types';

export const displayPrice = (price: number, dropDecimal = false) => {
  const formatted = (Math.abs(price) / 100).toFixed(dropDecimal ? 0 : 2);
  return price >= 0 ? `$${formatted}` : `-$${formatted}`;
};

export const accessPlanToDisplayName = (plan: AccessPlans) => {
  switch (plan) {
    case AccessPlans.BASIC:
      return 'Basic';
    case AccessPlans.PRO:
      return 'Pro';
    case AccessPlans.ENTRY:
      return 'Entry';
    case AccessPlans.STANDARD:
      return 'Standard';
    case AccessPlans.NONE:
      return 'None';
  }
};
export const accessPlanToStripePlan = (plan: AccessPlans) => {
  switch (plan) {
    case AccessPlans.BASIC:
      return StripePlans.BASIC;
    case AccessPlans.PRO:
      return StripePlans.PRO;
    case AccessPlans.ENTRY:
      return StripePlans.ENTRY;
    case AccessPlans.STANDARD:
      return StripePlans.STANDARD;
    case AccessPlans.NONE:
      return StripePlans.NONE;
  }
};

export function stripePlanToAccessPlan(plan?: string) {
  switch (plan?.toLowerCase()) {
    case StripePlans.BASIC:
      return AccessPlans.BASIC;
    case StripePlans.ENTRY:
      return AccessPlans.ENTRY;
    case StripePlans.STANDARD:
      return AccessPlans.STANDARD;
    case StripePlans.PRO:
      return AccessPlans.PRO;
    default:
      return AccessPlans.NONE;
  }
}
